module.exports = __webpack_public_path__ + "static/media/table_background_high_small.0e63c9f8.jpg";